var _rect, _path, _path2, _path3, _circle, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoInstagramConnected(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1925 10.1284C23.1925 9.39725 22.5999 8.80687 21.8715 8.80687C21.143 8.80687 20.5499 9.39725 20.5499 10.1284C20.5499 10.8569 21.143 11.4473 21.8715 11.4473C22.5999 11.4473 23.1925 10.8569 23.1925 10.1284",
    fill: "url(#paint0_linear_10500_15355)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9527 20.4444C24.9038 21.517 24.7244 22.0997 24.5755 22.4868C24.3754 23 24.1368 23.3669 23.7497 23.7518C23.367 24.1367 23 24.3748 22.4868 24.5727C22.0998 24.7238 21.5148 24.9037 20.4423 24.9549C19.2827 25.006 18.9391 25.0168 15.9987 25.0168C13.0609 25.0168 12.7146 25.006 11.555 24.9549C10.4825 24.9037 9.90027 24.7238 9.51318 24.5727C8.99729 24.3748 8.63307 24.1367 8.24818 23.7518C7.86056 23.3669 7.62193 23 7.42459 22.4868C7.27561 22.0997 7.09352 21.517 7.04729 20.4444C6.99078 19.2848 6.98042 18.9358 6.98042 16.0013C6.98042 13.0609 6.99078 12.7145 7.04729 11.555C7.09352 10.4824 7.27561 9.90022 7.42459 9.50986C7.62193 8.99724 7.86056 8.63245 8.24818 8.24756C8.63307 7.86325 8.99729 7.62457 9.51318 7.42454C9.90027 7.27287 10.4825 7.09563 11.555 7.04454C12.7146 6.99342 13.0609 6.98037 15.9987 6.98037C18.9391 6.98037 19.2827 6.99342 20.4423 7.04454C21.5148 7.09563 22.0998 7.27287 22.4868 7.42454C23 7.62457 23.367 7.86325 23.7497 8.24756C24.1368 8.63245 24.3754 8.99724 24.5755 9.50986C24.7244 9.90022 24.9038 10.4824 24.9527 11.555C25.0065 12.7145 25.0196 13.0609 25.0196 16.0013C25.0196 18.9358 25.0065 19.2848 24.9527 20.4444V20.4444ZM26.9332 11.4648C26.8794 10.2927 26.6945 9.49192 26.42 8.79448C26.1406 8.0709 25.766 7.45769 25.1528 6.84448C24.5423 6.234 23.9291 5.85942 23.2055 5.57675C22.5053 5.30492 21.7073 5.1179 20.5347 5.06682C19.3621 5.01026 18.9875 4.99995 15.9987 4.99995C13.0125 4.99995 12.6353 5.01026 11.4626 5.06682C10.2927 5.1179 9.49524 5.30492 8.7918 5.57675C8.07095 5.85942 7.45774 6.234 6.84726 6.84448C6.23405 7.45769 5.85947 8.0709 5.57733 8.79448C5.3055 9.49192 5.12069 10.2927 5.06413 11.4648C5.01305 12.6374 5 13.0125 5 16.0013C5 18.9875 5.01305 19.362 5.06413 20.5346C5.12069 21.7045 5.3055 22.5047 5.57733 23.2055C5.85947 23.9263 6.23405 24.5423 6.84726 25.1527C7.45774 25.7632 8.07095 26.1405 8.7918 26.4227C9.49524 26.6945 10.2927 26.8793 11.4626 26.9331C12.6353 26.987 13.0125 27 15.9987 27C18.9875 27 19.3621 26.987 20.5347 26.9331C21.7073 26.8793 22.5053 26.6945 23.2055 26.4227C23.9291 26.1405 24.5423 25.7632 25.1528 25.1527C25.766 24.5423 26.1406 23.9263 26.42 23.2055C26.6945 22.5047 26.8794 21.7045 26.9332 20.5346C26.987 19.362 27 18.9875 27 16.0013C27 13.0125 26.987 12.6374 26.9332 11.4648V11.4648Z",
    fill: "url(#paint1_linear_10500_15355)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9987 19.6653C13.9748 19.6653 12.3325 18.0257 12.3325 16.0018C12.3325 13.9746 13.9748 12.3328 15.9987 12.3328C18.0232 12.3328 19.6676 13.9746 19.6676 16.0018C19.6676 18.0257 18.0232 19.6653 15.9987 19.6653V19.6653ZM15.9987 10.3497C12.8788 10.3497 10.3521 12.8819 10.3521 16.0018C10.3521 19.1189 12.8788 21.6484 15.9987 21.6484C19.1186 21.6484 21.6481 19.1189 21.6481 16.0018C21.6481 12.8819 19.1186 10.3497 15.9987 10.3497Z",
    fill: "url(#paint2_linear_10500_15355)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 6,
    fill: "#21C07D",
    stroke: "white",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10500_15355",
    x1: 5.19848,
    y1: 26.7724,
    x2: 25.1677,
    y2: 6.80326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFD521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501119,
    stopColor: "#F50000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B900B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.950079,
    stopColor: "#B900B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B900B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10500_15355",
    x1: 5.19844,
    y1: 26.7999,
    x2: 25.1841,
    y2: 6.81431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFD521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501119,
    stopColor: "#F50000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B900B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.950079,
    stopColor: "#B900B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B900B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10500_15355",
    x1: 5.20365,
    y1: 26.8009,
    x2: 25.1845,
    y2: 6.8201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFD521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501119,
    stopColor: "#F50000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B900B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.950079,
    stopColor: "#B900B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B900B4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoInstagramConnected);
export default __webpack_public_path__ + "static/media/logo_instagram_connected.71f3dbaff563cf27b0a1d78943ef2cb3.svg";
export { ForwardRef as ReactComponent };